import React from 'react';
import ReactSelect from '../../selects/react-select';
import '../fieldstyle.css'

const FieldSelect = ({ input, label, options, disabled, meta: { touched, error, invalid, warning } }) => (
    <div className={`grupo-form ${touched && invalid ? 'tiene-error' : ''}`}>
    <label className='label-control'>{label}</label>
    <div>
      < ReactSelect {...input} value={input.value} func_onChange={(value) => {if(Array.isArray(value)){value=null}; input.onChange(value)}} func_onBlur={() => input.onBlur(input.value.value)} options={options}
      disabled={disabled}/>
      <div className='descrip-error'>
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
      </div>
    </div>
  </div>
)
export default FieldSelect